import _extends from 'babel-runtime/helpers/extends';

import DynamicForm from '@/components/DynamicForm'; // 动态表单组件

export default {
  components: {
    DynamicForm: DynamicForm
  },

  props: {
    formConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    formItemList: {
      type: [Object, Array],
      required: true
    },

    searchConfig: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },

    searchButton: {
      type: Object
    },

    resetButton: {
      type: Object
    },
    searchText: {
      type: String,
      default: '搜索'
    },

    resetText: {
      type: String,
      default: '重置'
    }

  },

  computed: {
    innerFormConfig: function innerFormConfig() {
      return _extends({
        inline: true,
        labelPosition: 'left',
        labelWidth: ''
      }, this.formConfig);
    }
  },

  methods: {
    _handleChange: function _handleChange(val, prop, formItem) {},
    _onClickReset: function _onClickReset() {
      this.resetFields();
      this.$emit('reset', this.formValue);
    },
    _onClickSearch: function _onClickSearch() {
      var _this = this;

      this.validate().then(function () {
        _this.$emit('search', _this.formValue);
      });
    },


    /**
     * 重置表单
     */
    resetFields: function resetFields() {
      return this.$refs.form.resetFields();
    },
    validate: function validate() {
      var _$refs$form;

      return (_$refs$form = this.$refs.form).validate.apply(_$refs$form, arguments);
    },
    _isFocusForm: function _isFocusForm() {
      var _this2 = this;

      var checkIsInside = function checkIsInside(ele) {
        if (ele.parentElement) {
          if (ele.parentElement === _this2.$refs.form.$el) {
            return true;
          }
          return checkIsInside(ele.parentElement);
        }
        return false;
      };
      console.log(checkIsInside(document.activeElement));
      return checkIsInside(document.activeElement);
    },
    _handleKeyup: function _handleKeyup(evt) {
      if (evt.keyCode === 13 && this._isFocusForm()) {
        this._onClickSearch();
      }
    }
  }
};